import React from 'react'
import {OrderCard} from '../../shared'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '_metronic/helpers'
import replace from 'lodash/replace'
import NumberFormat from 'react-number-format'
import {simpleCurrency} from 'app/format/currency'

interface Props {
  refundPrice: number | any
  onAmountChange: (val: any) => void
  maxRefundPrice: number | any
  title: string
  brand: string
  disabled?: boolean
}

export const RefundAmount: React.FC<Props> = ({
  title,
  brand,
  onAmountChange,
  maxRefundPrice,
  refundPrice,
  disabled = false,
}) => {
  const handleRefund = (e: any) => {
    let {value} = e.target
    value = replace(value, '$', '')
    onAmountChange(value)
  }
  const validate = (e: any) => {
    const {value} = e
    if (value <= maxRefundPrice) {
      return true
    }
    return false
  }

  return (
    <OrderCard title='Refund Amount'>
      <div>
        <label className='form-label'>{title}</label>
        <div className='d-flex align-items-center position-relative my-1'>
          <span className='position-absolute px-3 mb-3'>
            <SVG
              id={`icon${brand}`}
              src={toAbsoluteUrl(`/media/icons/corksy/payment/${brand}.svg`)}
              className='svg-icon-2hx me-2'
            />
          </span>
          <NumberFormat
            className='form-control w-100 mb-3 ps-17'
            placeholder='$0.0'
            prefix='$'
            value={refundPrice}
            isAllowed={validate}
            decimalScale={2}
            allowNegative={false}
            onChange={handleRefund}
            disabled={disabled}
            onValueChange={({floatValue}) => {
              onAmountChange(floatValue)
            }}
          />
        </div>
        {maxRefundPrice > 0 && (
          <div className='mb-4'>Maximum refund: {simpleCurrency(maxRefundPrice)}</div>
        )}
      </div>
    </OrderCard>
  )
}

export default React.memo(RefundAmount)
